import { Component, OnInit, Input } from '@angular/core';
import { SetService, JwtService, PageService } from 'ngx-block-core';
import { HttpService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sucu04-weiget0020005',
  templateUrl: './sucu04-weiget0020005.component.html',
  styleUrls: ['./sucu04-weiget0020005.component.less']
})
export class Sucu04Weiget0020005Component implements OnInit {



  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'
  value;
  @Input() sets = {
    blockCode: "sucublock53",
    blockId: "",
    blockName: "穿梭框",
    layoutId: "",
    blockType: "formBlock",
    blockChildType: 'transfer',
    versionCode: 7,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    events: [
      {
        label: "可用不可用",
        value: "isable",
        data: {
          setParams: ["不可用值", '可用值', 'num']
        }
      }
    ],
    styles: {
      nzShowSearch: false,
      nzTitles: ["", ""],
      nzOperations: ["", ""],
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 24,
        nzLayout3: 0,
        nzLayout4: 24,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzNoSee: false,
      nzExpandId:"",
    },
    datas: {
      nzDataSource: "",
      nzData: [],
      nzDynamicSearch: {
        nzDynamicSqlLeft: "select T_TEST001_ID AS ID , T_TEST001_ID AS LABEL ,T_TEST001_ID AS VALUE from T_TEST001 WHERE T_TEST001_ID>'20190215205901' AND T_TEST001_ID<'20190216202050' ",
        nzDynamicSqlRight: "select T_TEST001_ID AS ID ,T_TEST001_ID AS LABEL ,T_TEST001_ID AS VALUE from T_TEST001 WHERE T_TEST001_ID<'20190215181240' ",
        nzKeep: "right",
        nzOptions: 'title'
      },
      nzLinkage: {
        nzUsed: true,
        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzDynamicSql: ""
      }
    }
  };
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' }
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "可搜索 : ", nzKeys: ['styles', 'nzShowSearch'], }
              },
              {
                name: 'input',
                inputs: { nzText: "标题1 : ", nzKeys: ['styles', 'nzTitles', 0], }
              },
              {
                name: 'input',
                inputs: { nzText: "标题2 : ", nzKeys: ['styles', 'nzTitles', 1], }
              },
              {
                name: 'input',
                inputs: { nzText: "操作文案1 : ", nzKeys: ['styles', 'nzOperations', 0], }
              },
              {
                name: 'input',
                inputs: { nzText: "操作文案2 : ", nzKeys: ['styles', 'nzOperations', 1], }
              },
              {
                name: 'input',
                inputs: {
                  nzText: "左侧动态sql : ", nzKeys: ['datas', 'nzDynamicSearch', 'nzDynamicSqlLeft'], nzType: "textarea",
                  nzAutosize: { minRows: 3, maxRows: 6 },
                  Layout1: [2, 8, 24]
                }
              },
              {
                name: 'input',
                inputs: {
                  nzText: "右侧动态sql : ", nzKeys: ['datas', 'nzDynamicSearch', 'nzDynamicSqlRight'], nzType: "textarea",
                  nzAutosize: { minRows: 3, maxRows: 6 }, Layout1: [2, 8, 24]
                }
              },
              {
                name: 'button',
                inputs: { nzText: ['刷新'] },
                outputs: {
                  onClick1: (event) => {
                    this.initSelected()
                  }
                }
              },
              {
                name: 'radio',
                inputs: {
                  nzText: "重复保留 : ", nzKeys: ['datas', 'nzDynamicSearch', 'nzKeep'],
                  nzData: [{ value: "left", label: "左" }, { value: "right", label: "右" }], nzPopContent: ['左右的sql有重复值时，保留哪一边', '需配置比对项']
                },
                outputs: {
                  ngModelChange: (event) => {
                    this.setService.onReLoadbBlock(this.layoutid)
                  }
                }
              },
              {
                name: 'radio',
                inputs: {
                  nzText: "比对项 : ", nzKeys: ['datas', 'nzDynamicSearch', 'nzOptions'],
                  nzData: [{ value: "title", label: "LABEL" }, { value: "key", label: "VALUE" }], nzPopContent: ['判断重复的依据', '具体请根据动态SQL']
                },
                outputs: {
                  ngModelChange: (event) => {
                    this.setService.onReLoadbBlock(this.layoutid)
                  }
                }
              },
              { name: 'nzLayout', inputs: { nzType: '穿梭框', nzShow: true } },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "transfer";
                  }
                }
              },
            ]
          }
        ]
      },

      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      }

    ]
  }
  setData = []

  constructor(
    public setService: SetService,
    private http: HttpService,
    private activatedRoute: ActivatedRoute,
    private jwtService: JwtService,
    private pageService: PageService
  ) { }

  ngOnInit() {
    this.baseInit();
    this.autoUpdate()
    this.initSelected();

    this.autoUpdate();
  }
  autoUpdate() {

    //vc:2
    //联动
    if (this.sets.versionCode < 2) {
      if (typeof this.sets.datas.nzLinkage == "undefined") {
        this.sets.datas['nzLinkage'] = {
          nzUsed: true,
          nzEvents: [

          ],
        };
        this.sets.datas['nzLinkageData'] = {
          nzDynamicSql: ""
        }
      }
      this.sets.versionCode = 2;
    }


    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

      this.sets.blockCode = "sucublock53";

      this.sets.versionCode = 3;
    }
    //v4,表单输入
    if (this.sets.versionCode < 4) {

      this.sets.attributes = ['form', 'nzFormGroupData', 'nzLayout'];

      this.sets.versionCode = 4;
    }
    //v4,表单输入
    if (this.sets.versionCode < 5) {

      this.sets.styles.nzNoSee = false;
      this.sets.versionCode = 5;
    }

    if (this.sets.versionCode < 6) {

      this.sets['events'] = [

        {
          label: "可用不可用",
          value: "isable",
          data: {
            setParams: ["不可用值", '可用值', 'num']
          }
        }
      ],


        this.sets.versionCode = 6;
    }
    if (this.sets.versionCode < 7) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 7;
    }

  }

  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "transfer";
        this.nzFormGroupData['nzSearchType'] = "=";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
    this.Listening();
  }
  list: any[] = [];
  listJson = {};
  disabled = false;
  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: ""
  }
  initSelected(): void {
    let leftsql = this.sets.datas.nzDynamicSearch.nzDynamicSqlLeft;

    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) leftsql = leftsql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) leftsql = leftsql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) leftsql = leftsql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);

    let rightsql = this.sets.datas.nzDynamicSearch.nzDynamicSqlRight;

    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) rightsql = rightsql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) rightsql = rightsql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) rightsql = rightsql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);


    if (leftsql.indexOf("@linkage") == -1 && rightsql.indexOf("@linkage") == -1) {
      this.listJson = {};
      this.list = [];
      const sql = [{
        sql: leftsql,
        direction: 'left'
      },
      {
        sql: rightsql,
        direction: 'right'
      }]
      console.log(sql)
      sql.forEach(sql => {
        if (sql.sql != "") {
          let body = {
            "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql.sql), this.layoutid),
            "pageSize": 0,
            "nowPage": 0,
            "paramMap": [],
            "tableSort": [],
            "searchMap": {}
          }

          console.log("选项body:" + JSON.stringify(body));
          this.http.postHttp("/system/dynamicSql", body).subscribe(
            (data: any) => {
              console.log("选项Left:" + JSON.stringify(data));

              data.data.list.forEach(element => {
                let item = {
                  id: element['ID'],
                  key: element['VALUE'],
                  title: element['LABEL'],
                  direction: sql.direction,
                  first: sql.direction,
                  icon: '',
                  disabled: false,
                  checked: false
                }
                let key = item[this.sets.datas.nzDynamicSearch.nzOptions]
                if (typeof this.listJson[key] == "undefined") {
                  this.list.push(item)
                  this.listJson[key] = item
                } else {
                  if (this.sets.datas.nzDynamicSearch.nzKeep == "left") {
                    this.listJson[key]['direction'] = 'left'
                    this.listJson[key]['first'] = 'left'
                  }
                  else {
                    this.listJson[key]['direction'] = 'right'
                    this.listJson[key]['first'] = 'right'
                  }

                }
              });
              this.list = [...this.list]
            });
        }

      });
    }





  }

  select(ret: {}): void {
    console.log('nzSelectChange', ret);
  }

  change(ret: {}): void {

    console.log('nzChange', JSON.stringify(ret));
    ret['list'].forEach(element => {
      element['direction'] = ret['to'];
    });
    // console.log('nzChange2',JSON.stringify(this.list));


  }

  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    this.setService.deleteEvent(this.blockid);
  }
  nzDisabled=false;
  Listening() {
    console.log("Listening", this.blockid)
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("data", JSON.stringify(data))
          switch (data['type']) {
            case 'linkagevalue':
              break;
            case 'linkagedatasource':
              console.log("linkagedatasource", data['datas']['value'])
              this.linkValue.linkage = data['datas']['value'];
              this.initSelected();
              break;
            case 'linkagedatasource2':
              console.log("linkagedatasource2", data['datas']['value'])
              this.linkValue.linkage2 = data['datas']['value'];
              this.initSelected();
              break;
            case 'linkagedatasource3':
              console.log("linkagedatasource3", data['datas']['value'])
              this.linkValue.linkage3 = data['datas']['value'];
              this.initSelected();
              break;
            case 'isable':
              console.log("isabletr", JSON.stringify(data))
              if (data.datas.value == data.datas.param0) {
                //disable
                // this.form.get(this.nzFormGroupData.nzKey).disable();
                this.nzDisabled=true;
              } else if (data.datas.value == data.datas.param1) {
                // enable
                // this.form.get(this.nzFormGroupData.nzKey).enable();
                this.nzDisabled=false;
              }
              break;
              case 'check_hasTansfer':
                  this.check_hasTansfer(data['datas'])
                break;
            default:
              break;
          }


        }
      )
    }, !this.static ? 100 : 0);


  }
  check_hasTansfer(data) {
    let num=0;
    this.list.forEach(element => {
      if( element['direction']=='right' && element['first'] == 'left') num++; 
    });
    console.log("this.list",this.list,num,data)
    if(num>=data.num){
      this.setService.sendEvent(data.blockid, 'check_hasTansfer_ans', true)
    }else{
      this.setService.sendEvent(data.blockid, 'check_hasTansfer_ans', false)
    }


  }

  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(

        data => {
          switch (data['type']) {
            case 'refresh':
              this.initSelected()
              // this.setService.onReLoadbBlock(this.layoutid)
              break;
            default:
              break;
          }
        }
      )
    }, 100);

  }




}



